/* global axios */
import ApiClient from './ApiClient';

class AiStudioAPI extends ApiClient {
  constructor() {
    super('ai_studio', { accountScoped: true });
  }

  models() {
    return axios.get(`${this.url}/models`);
  }

  conversations() {
    return axios.get(`${this.url}/conversations`);
  }

  showConversation(id) {
    return axios.get(`${this.url}/conversations/${id}`);
  }

  createConversation(modelId) {
    return axios.post(`${this.url}/conversations`, { model_id: modelId });
  }

  deleteConversation(id) {
    return axios.delete(`${this.url}/conversations/${id}`);
  }

  sendMessage(id, content, modelId, extras = {}) {
    return axios.post(`${this.url}/conversations/${id}/messages`, {
      content,
      model_id: modelId,
      ...extras,
    });
  }

  // Anexo do chat (imagem/PDF/áudio/texto) — processado no servidor.
  uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/uploads`, formData);
  }

  generateImage(id, prompt, quality = 'standard') {
    return axios.post(`${this.url}/conversations/${id}/images`, {
      prompt,
      quality,
    });
  }
}

export default new AiStudioAPI();
